const translations = {
    createWorkOrder: 'Create Work Order'
};

export default translations;
